import React from 'react';

// Minimal inline markdown → React. LLM replies naturally use **bold**, *italic*
// and `code`; without this they'd render as literal asterisks/backticks. Newlines
// are preserved by the container's `white-space: pre-wrap`, so we don't add <br>.
const TOKEN = /\*\*([^*]+)\*\*|\*([^*]+)\*|`([^`]+)`/;

export function renderRich(text: string): React.ReactNode {
  const out: React.ReactNode[] = [];
  let rest = text || '';
  let key = 0;
  let m: RegExpMatchArray | null;
  // eslint-disable-next-line no-cond-assign
  while ((m = rest.match(TOKEN)) && m.index != null) {
    if (m.index > 0) out.push(rest.slice(0, m.index));
    if (m[1] != null) out.push(<strong key={key++}>{m[1]}</strong>);
    else if (m[2] != null) out.push(<em key={key++}>{m[2]}</em>);
    else if (m[3] != null) out.push(<code key={key++}>{m[3]}</code>);
    rest = rest.slice(m.index + m[0].length);
  }
  if (rest) out.push(rest);
  return out;
}
